module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1516-5cba32b6c32343f5fd3b29ed754ef38c.png";